<template>
  <router-view></router-view>
  <Toast position="bottom-right" />
  <ConfirmDialog></ConfirmDialog>
</template>

<script>

</script>

<style>
@import './assets/styles/main.scss';

body {
  margin: 0;
  padding: 0;
  font-family: var(--font-family);
  background-color: var(--surface-ground);
  color: var(--text-color);
}

</style>
